<template>
  <v-toolbar flat color="transparent" class="toolbar">
    <v-layout justify-start>
      <v-flex shrink
        :class="['body-1 current breadcrumbs-wrap', { dragovered: config.status.breadcrumbs }]"
        @dragover="dragover(null)"
        @dragleave="dragleave(null)"
      >
        <div><font-awesome-icon :icon="['fas', 'folder-open']" class="blue--text" />&nbsp;{{ printCurrentDir }}</div>
        <v-list class="breadcrumbs">
          <v-list-tile v-for="item in getTailItems" :key="item.id"
            :class="{
              'grey': item.dragovering,
              'lighten-2': item.dragovering
            }"
            @drop="drop(item)"
            @dragover="dragover(item)"
            @dragleave="dragleave(item)"
            @click.stop="backward(item)">
            <v-list-tile-avatar><font-awesome-icon :icon="['fas', 'folder']" class="blue--text"></font-awesome-icon></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name ? item.name : '全てのファイル' }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>
import _ from 'lodash'
const DEF = {
  STATUS: {
    LOADING: false,
    MKDIR: false,
    BREADCRUMBS: false,
    IMPORT: false
  },
  STORE: {
    BOX: {
      TYPE: 'media',
      LABEL: 'メディア'
    }
  }
}
export default {
  name: 'clientFilerToolbar',
  components: {
  },
  props: [
    'lib',
    'status',
    'fixed'
  ],
  data () {
    return {
      config: {
        status: {
          mkdir: DEF.STATUS.MKDIR,
          upload: DEF.STATUS.UPLOAD,
          breadcrumbs: DEF.STATUS.BREADCRUMBS
        }
      },
      form: {
        lib: false
      },
      store: {
        authed: false,
        box: {
          type: DEF.STORE.BOX.TYPE,
          label: DEF.STORE.BOX.LABEL
        },
        items: []
      }
    }
  },
  methods: {
    init: function (id) {
      if (id) {
        this.$set(this.store, 'items', [{
          id: id,
          type: 'folder'
        }])
      } else {
        this.$set(this.store, 'items', [])
      }
    },
    upload: function (files) {
      if (files && files.length) {
        this.$emit('emit', {
          action: 'upload',
          data: files
        })
      }
    },
    mkdir: function () {
      if (this.store.items && this.store.items.length) {
        this.$emit('emit', {
          action: 'mkdir',
          data: this.store.items[0]
        })
      }
    },
    forward: function (item) {
      if (item && item.id) {
        if (this.store.items.length && this.store.items[0].type === 'shared') {
          item.tags.shared = true
        }
        this.store.items.unshift(item)
        if (item.tags && item.tags.authed) {
          this.$set(this.store, 'authed', item.tags.authed)
        }
      }
    },
    backward: function (item) {
      if (item && item.id) {
        let idx = this.store.items.findIndex(it => {
          return it.id === item.id
        })
        if (idx >= 0) {
          this.store.items.splice(0, idx + 1)
          const auths = this.store.items.filter(it => { return !!it.tags.authed })
          if (auths.length) {
            this.$set(this.store, 'authed', auths[auths.length - 1])
          } else {
            this.$set(this.store, 'authed', false)
          }
        }
        this.$emit('emit', {
          action: 'get',
          data: item
        })
      }
    },
    changeLibrary: function (req) {
      const { type, rid } = req
      let permits = {}
      if (type && rid) {
        this.$set(this.form, 'lib', false)
        this.$set(this.store, 'items', [])
        if (type === 'media') {
          this.$set(this.store, 'box', {
            type: 'media',
            label: 'メディア'
          })
          permits = {
            add: true,
            modify: true,
            trash: true,
            share: true
          }
        } else if (type === 'shared') {
          this.$set(this.store, 'box', {
            type: 'shared',
            label: '共有アイテム'
          })
          permits = {
            add: true,
            modify: true,
            trash: true,
            share: false
          }
        } else if (type === 'trash') {
          this.$set(this.store, 'box', {
            type: 'trash',
            label: 'ごみ箱'
          })
          permits = {
            add: false,
            modify: false,
            trash: false,
            share: false
          }
        } else if (type === 'arrange') {
          let idx = this.$props.lib.arranges.findIndex(it => {
            return it.mid === rid
          })
          if (idx >= 0) {
            this.$set(this.store, 'box', {
              type: 'arrange',
              label: this.$props.lib.arranges[idx].title
            })
          }
          permits = {
            add: false,
            modify: false,
            trash: true,
            share: false
          }
        }
        this.$emit('emit', {
          action: 'init',
          data: { type, rid, permits }
        })
      }
    },
    dragover: function (item) {
      if (item && item.id) {
        this.$set(item, 'dragovering', true)
      } else {
        this.$set(this.config.status, 'breadcrumbs', true)
      }
    },
    dragleave: function (item) {
      if (item && item.id) {
        this.$set(item, 'dragovering', false)
      } else {
        _.debounce(() => {
          if (this.store.items.filter(it => {
            return it.dragovering
          }).length === 0) {
            this.$set(this.config.status, 'breadcrumbs', false)
          }
        }, 100)()
      }
    },
    drop: function (item) {
      this.$set(this.config.status, 'breadcrumbs', false)
      if (item && item.id) {
        this.$set(item, 'dragovering', false)
        this.$emit('emit', {
          action: 'move',
          data: item
        })
      }
    },
    getCurrentDir: function () {
      return (this.store.items.length) ? this.store.items[0] : null
    }
  },
  computed: {
    isLocked () {
      return !!(
        this.store.items.length &&
        this.store.items[0].tags &&
        this.store.items[0].tags.authed
      )
    },
    isAuthed () {
      return !this.store.authed || (this.store.authed === this.$store.getters['author/get']('userid'))
    },
    isShared () {
      return !!(
        this.store.items.length &&
        this.store.items[0].type === 'shared'
      )
    },
    isRootShared () {
      return !!(this.store.items.length && this.store.items[this.store.items.length - 1].type === 'shared')
    },
    hasSharedDirectory () {
      return this.store.items.filter(it => { return it.tags && it.tags.shared }).length > 0
    },
    isFlight () {
      return !!(
        this.store.items.length &&
        this.store.items[0].type === 'flight'
      )
    },
    isRootFlight () {
      return !!(
        this.store.items.length &&
        this.store.items[this.store.items.length - 1].type === 'flight'
      )
    },
    isMkDiring () {
      return this.config.status.mkdir
    },
    isUploading () {
      return this.$props.status && this.$props.status.uploading
    },
    isAddable () {
      return this.$props.status && this.$props.status.permits.add
    },
    isLibrarySwappable () {
      return (
        this.$props.lib &&
        this.$props.lib.media
      )
    },
    isCoreLoading () {
      return this.$props.status && this.$props.status.loading
    },
    isSetCurrentDirectory () {
      return this.$props.status && this.$props.status.cd
    },
    isEmpty () {
      return !(
        this.store.items.length
      )
    },
    isSingle () {
      return !!(
        this.store.items.length &&
        this.store.items.length === 1
      )
    },
    printCurrentDir () {
      return (
        this.store.items.length &&
        this.store.items[0].name
      ) ? this.store.items[0].name : '全てのファイル'
    },
    printSelectedBoxLabel () {
      return this.store.box.label
    },
    getSelectedBoxIcon () {
      if (this.store.box.type === 'media') {
        return ['fas', 'books']
      } else if (this.store.box.type === 'trash') {
        return ['fas', 'trash']
      } else if (this.store.box.type === 'arrange') {
        return ['fas', 'file-contract']
      } else if (this.store.box.type === 'shared') {
        return ['fas', 'user-friends']
      } else {
        return []
      }
    },
    getItems () {
      return this.store.items
    },
    getTailItems () {
      return this.store.items.length ? this.store.items.filter(it => {
        return it.id !== this.store.items[0].id
      }) : []
    }
  }
}
</script>

<style lang="scss">
.filer {
  .toolbar {
    z-index: 1;
    .breadcrumbs-wrap {
      position: relative;
      height: $form_h;
      line-height: $form_h;
      cursor: default;
      &:hover,
      &.dragovered {
        .breadcrumbs {
          display: flex;
        }
      }
      .breadcrumbs {
        display: none;
        position: absolute;
        top: 0.95 * $form_h;
        left: 0;
        z-index: 8;
        box-shadow: $float;
        flex-direction: column;
        &:hover {
          display: flex;
        }
      }
    }
  }
}
</style>
